export default {
  chat: {
    confirmModals: {
      deleteChat: 'Are you sure you want to delete this chat? The chat will be deleted permanently!',
      removeMyself: 'Are you sure you want to leave this chat?',
      removeUserFromGroupChat: 'Are you sure you want to remove {{name}} from this group chat?',
      clearChatHistory: 'Are you sure you want to clear your chat history?',
    },
    toasts: {
      deleted: 'Chat has been successfully deleted',
      created: 'The group chat has been successfully created',
      update: 'Chat has been successfully updated',
      deleteChatHistory: 'Chat history has been successfully deleted',
      removeMyself: 'You left the chat successfully',
      addedUserToGroupChat: 'The user has been successfully added to this group chat',
    },
    replies: ' replies',
    reply: ' reply',
  },
};
